// Post-login landing page. Kinde redirects here with the access
// token in the URL fragment; the SDK consumes it and fires
// ``onRedirectCallback`` (wired in ``KindeAuthenticatedUI`` to
// populate ``KindeRedirectContext``). We then navigate the user
// back to wherever they came from.
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { KindeRedirectContext } from "./KindeRedirectContext";

export const LoginRedirect = () => {
  const navigate = useNavigate();
  const { redirectUrl } = useContext(KindeRedirectContext);

  useEffect(() => {
    if (!redirectUrl) {
      return;
    }
    if (redirectUrl === "/login-redirect") {
      navigate("/", { replace: true });
    } else {
      navigate(redirectUrl, { replace: true });
    }
  }, [navigate, redirectUrl]);

  return (
    <div
      style={{
        padding: "2rem",
        fontFamily: "var(--font-sans, system-ui)",
        color: "var(--ir-navy, #1a2244)",
      }}
    >
      Logging in…
    </div>
  );
};
